import { render, staticRenderFns } from "./my-information.vue?vue&type=template&id=203d09b0&scoped=true"
import script from "./my-information.vue?vue&type=script&lang=js"
export * from "./my-information.vue?vue&type=script&lang=js"
import style0 from "./my-information.vue?vue&type=style&index=0&id=203d09b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203d09b0",
  null
  
)

export default component.exports